<template>
  <div>
    <el-row class="foot-area">
      <el-col :span="24">练习进度: {{(current!=null?current:0)+1}}/{{total!=null?total:1}}</el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props:['current','total']
}
</script>
<style scoped>
.foot-area{
  font-size: 1.3em
}
</style>